import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, RedirectionFeatureState } from './state';

const featureSelector = createFeatureSelector<RedirectionFeatureState>(featureKey);

export const RedirectionSelectors = {
  selectViewState: createSelector(featureSelector, (state) => state.redirection.viewState),
};
